const getInventoryListStyles = theme => ({
  marginTop: theme.spacing(4),
  display: 'grid',
  gap: theme.spacing(2)
});
const getInventoryAddButtonStyles = theme => ({
  marginTop: theme.spacing(2)
});
const getInventoryWeightNoteStyles = () => ({
  textTransform: 'uppercase'
});

export { getInventoryAddButtonStyles, getInventoryListStyles, getInventoryWeightNoteStyles };
//# sourceMappingURL=InventoryStyles.js.map
